// Packages
import ListItem from 'modules/Settings/components/ListItem';
import PropTypes from 'prop-types';

const SettingsList = ({ isLoading, items, onChange }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='SettingsList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No settings to show here</h3>
		)
	}


	// Data State
	return (
		<div className='SettingsList'>

			{items.map((item, index) => {

				return (
						<ListItem 
							{...item} 
							key={index}
							isLoading={false}
							onChange={() => {onChange()}}
						/>
				)
				
			})}
	
		</div>
	)
}

SettingsList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
}

SettingsList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
}

export default SettingsList;